import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Popconfirm,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';
import camera from '../../assets/images/icon/camera.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

const dateFormat = 'YYYY-MM-DD';
const storedFiles=[];
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			fees_details : [],
			reply : [],
			ticket_no : '',
			t_status : '',
			t_type : '',
			message : '',
			is_reply : 0,
			is_satisfied : 0,
			loading : false,
		}
		this.handleChange = this.handleChange.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.handleClosed = this.handleClosed.bind(this);	
	}

	componentWillMount() {
		if(document.querySelector(".loader-wrapper")){
			document.querySelector(".loader-wrapper").style = "display: none";
		}
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var permission = storedArray['data'][0]['permission'];
		var type = storedArray['data'][0]['type'];
		//alert(type);
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'],user_type : type,permission : permission });
		this.checkData();
		setInterval(() => {
			this.checkData();
		}, 60000);
		}
	}
	
	scrollBottom = () =>{
	   //this.messagesEnd.scrollIntoView({ behavior: "smooth" });
	};
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 school_id : storedArray['data'][0]['school_id'], 
			 user_id : storedArray['data'][0]['user_id'], 
			 id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var id = this.props.match.params.id;
			var app = {user_id : user_id,id:id,school_id:school_id,type:type}
			getData('erp/ticket_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							fees_details: result['data'],
						});	
						if(result['data'].length > 0){
							this.setState({
								ticket_no: result['data'][0]['ticket_no'],
								is_reply: result['data'][0]['is_reply'],
								is_satisfied: result['data'][0]['is_satisfied'],
								reply: result['data'][0]['reply'],
								t_type: result['data'][0]['type'],
								t_status: result['data'][0]['status'],
							});	
						}
					}else{
						this.setState({
							fees_details: [],
						});
					}
				}
			});				
	}
	}
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.message != ''){
				this.setState({ loading: true });
				var app = {
					user_id: this.state.user_id,
					id: this.props.match.params.id,
					message: this.state.message,
				}
				getData('erp/ticket_reply',app).then((result) => {
					if(result.status==400){
						message.config({ top: 150});
						message.error(result.message,2);
						this.setState({ loading: false });
					}
					if(result.status==200){
						message.config({ top: 150});
						message.success('Message Send',2);
						this.setState({ loading: false,message: ''});
						this.checkData();
						this.scrollBottom();
					}
				})
			}else{
				message.error('Please Enter Message',2);	
			}
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	handleClosed=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				user_id: this.state.user_id,
				id: this.props.match.params.id
			}
			getData('erp/ticket_closed',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Ticket Closed',2);
					this.setState({ loading: false,message: ''});
					this.checkData();
				}
			});
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };

	handleChange = ({ fileList }) => this.setState({ fileList });

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <img src={person} class="profile-img" />
        <img src={camera} class="profile-img-cam" />
      </div>
    );	
					
		return (
		<>
			
			<div class="mobile_view">
			<div class="row bred">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						<h4 class="page-title"> 
							<i class="mdi mdi-apple-keyboard-command title_icon"></i>Ticket No : {this.state.ticket_no}
							<span class="tic-span ml-4">Ticket Status : 
							{(() => {
								if (this.state.t_status == 'open') {
									return (
										 <span class={`ticket-status bg-green ml-1`}> {this.state.t_status}</span>
									)
								}else if(this.state.t_status == 'process'){
									return (
										 <span class={`ticket-status bg-orange ml-1`}> {this.state.t_status}</span>
									)
								}else if(this.state.t_status == 'closed'){
									return (
										 <span class={`ticket-status bg-red ml-1`}> {this.state.t_status}</span>
									)
								}else{
									return (
										<></>
									)
								}
							})()}
							
							
							
							</span>
							<div class="breadcrumb-wrapper">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
										<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
										</a>
									</li>
									<li class="breadcrumb-item">
										<a href={`https://erp.kidzonia.co.in/panel/admin/parents-concern`} class="router-link-active" target="_self">
										Parents Concern
										</a>
									</li>
									<li class="breadcrumb-item"> View </li>
								</ol>
							</div>
						</h4>
					</div>
					</div>
					</div>
				</div>
			
			<div id="main" class="bg-off">
         <div class="row">
	
			  
			<div class="col-md-12 ex-padd">
            
            <div class="view-Profile child-profile view-Profile-mobile chat-application">
			   <div class="col-md-12 mb-20 card-content iq-card no-padd">
                  <section class="invoice-list-wrapper section food ">
					<div class="d-flex children  bg-color-1 mb-20 bg-color-1 iq-card2 form-group">
						<div class="col-md-12 no-padd">
						<div class="content-right">
                <div class="content-wrapper">
                    <div class="content-header row">
                    </div>
                    <div class="content-body">
                        <div class="chat-overlay"></div>
                        <section class="chat-app-window">
                            <div class="active-chat ">
                                <div class="chat_navbar">
                                    <header class="chat_header d-flex justify-content-between align-items-center p-1">
                                        <div class="vs-con-items  align-items-center">
                                            <div class="sidebar-toggle d-block d-lg-none mr-1"><i class="feather icon-menu font-large-1"></i></div>
                                            <h4 class="mb-0">Concern Type : {this.state.t_type}
											 
											</h4>
                                            
                                        </div>
										{(this.state.user_type == 'admin' || this.state.user_type == 'school' || this.state.permission.find(element => element == 54)) && (<> 
										{this.state.is_reply == '1' && (<>
										 <Button className="right ticket-closed-button" onClick={this.handleClosed} loading={this.state.loading}>Close Ticket</Button>
										 </>)}
										</>)}
                                    </header>
                                </div>
								
                                <div class="user-chats">
                                    <div class="chats">
									    
										{this.state.reply.map((list) => (
										<>
										
										{list.type == 'staff' && (<>
                                        <div class="chat">
                                            <div class="chat-avatar">
                                                {list.name}
                                            </div>
                                            <div class="chat-body">
                                                <div class="chat-content">
                                                    <p>{list.message}</p>
													<span>{list.added_date}</span>
                                                </div>
                                            </div>
                                        </div>
										</>)}
										
										{list.type == 'student' && (<>
                                        <div class="chat chat-left">
                                            <div class="chat-avatar">
                                               {list.name}
                                            </div>
                                            <div class="chat-body">
                                                <div class="chat-content">
                                                    <p>{list.message}</p>
													<span>{list.added_date}</span>
                                                </div>
                                            </div>
                                        </div>
										</>)}
										
										</>
										))}
                                        
                                    </div>
                                </div>
								{(this.state.user_type == 'admin' || this.state.user_type == 'school' || this.state.permission.find(element => element == 54)) && (<> 
								
								{this.state.is_reply == '1' && (<>
                                <div class="chat-app-form" >
                                    <form class="chat-app-input d-flex" onsubmit="enter_chat();" action="javascript:void(0);">
								<TextArea rows={0} class="form-control message mr-1 ml-50" id="iconLeft4-1" placeholder="Type your message" name="message" onChange={this.handleSizeChange} value={this.state.message}/>
                                        
                                        <Button type="button" className="btn btn-primary send" onClick={this.handleSubmit} loading={this.state.loading} ><i class="fa fa-paper-plane-o d-lg-none"></i> <span class="d-none d-lg-block">Send</span></Button>
                                    </form>
                                </div>
								</>)}
								
								</>)}
                            </div>
                        </section>
                        
                        
                        

                    </div>
                </div>
            </div>
						</div> 
					</div> 
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
